import { IIsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDataTransferObject } from "./Isilog.IsiFramework.IsiDataTransferObject";
import { IsiDtoPresentationLogicResponse } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IIsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";
import { IsiDtoPresentationLogicRequest } from "./Isilog.IsiComponent.IsiDataTransferObject";

export interface IIsiDtoPlDiagHeaderResponse extends IIsiDtoPresentationLogicResponse  {
    getDiagHeaderResult?: IIsiDtoPlDiagHeaderResult;
}
export interface IIsiDtoPlDiagHeaderResult extends IIsiDataTransferObject  {
    diagHeaderStrResult?: string;
}
export class IsiDtoPlDiagHeaderResult extends IsiDataTransferObject implements IIsiDtoPlDiagHeaderResult {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.DiagHeader.IsiDtoPlDiagHeaderResult, Isilog.IsiComponent.IsiDataTransferObject";
    diagHeaderStrResult?: string;

    constructor(data?: IIsiDtoPlDiagHeaderResult) {
        super(data);
        if (data) {
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.diagHeaderStrResult = _data["diagHeaderStrResult"] !== undefined ? _data["diagHeaderStrResult"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlDiagHeaderResult): IsiDtoPlDiagHeaderResult {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlDiagHeaderResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["diagHeaderStrResult"] = this.diagHeaderStrResult !== undefined ? this.diagHeaderStrResult : <any>null;
        return data;
    }
}
export class IsiDtoPlDiagHeaderResponse extends IsiDtoPresentationLogicResponse implements IIsiDtoPlDiagHeaderResponse {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.DiagHeader.IsiDtoPlDiagHeaderResponse, Isilog.IsiComponent.IsiDataTransferObject";
    getDiagHeaderResult?: IsiDtoPlDiagHeaderResult;

    constructor(data?: IIsiDtoPlDiagHeaderResponse) {
        super(data);
        if (data) {
            this.getDiagHeaderResult = data.getDiagHeaderResult && !(<any>data.getDiagHeaderResult).toJSON ? new IsiDtoPlDiagHeaderResult(data.getDiagHeaderResult) : <IsiDtoPlDiagHeaderResult>this.getDiagHeaderResult;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.getDiagHeaderResult = _data["getDiagHeaderResult"] ? IsiDtoPlDiagHeaderResult.fromJS(_data["getDiagHeaderResult"]) : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlDiagHeaderResponse): IsiDtoPlDiagHeaderResponse {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlDiagHeaderResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["getDiagHeaderResult"] = this.getDiagHeaderResult != null ? (<any>this.getDiagHeaderResult).toJSON() : <any>null;
        return data;
    }
}
export interface IIsiDtoPlDiagHeaderRequest extends IIsiDtoPresentationLogicRequest  {
    response?: IIsiDtoPlDiagHeaderResponse;
    type?: string;
}
export class IsiDtoPlDiagHeaderRequest extends IsiDtoPresentationLogicRequest implements IIsiDtoPlDiagHeaderRequest {
    $type?: string = "Isilog.IsiComponent.IsiDataTransferObject.UI.PresentationLogic.DiagHeader.IsiDtoPlDiagHeaderRequest, Isilog.IsiComponent.IsiDataTransferObject";
    response?: IsiDtoPlDiagHeaderResponse;
    type?: string;

    constructor(data?: IIsiDtoPlDiagHeaderRequest) {
        super(data);
        if (data) {
            this.response = data.response && !(<any>data.response).toJSON ? new IsiDtoPlDiagHeaderResponse(data.response) : <IsiDtoPlDiagHeaderResponse>this.response;
        }
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.response = _data["response"] ? IsiDtoPlDiagHeaderResponse.fromJS(_data["response"]) : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data?: IIsiDtoPlDiagHeaderRequest): IsiDtoPlDiagHeaderRequest {
        data = typeof data === 'object' ? data : {};
        let result = new IsiDtoPlDiagHeaderRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any): any {
        data = super.toJSON(data);

        data["$type"] = this.$type;
        data["response"] = this.response != null ? (<any>this.response).toJSON() : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}
